import { CompanyResponseInterface } from '../../../interfaces/response/company/company-response-interface';

export class CompanyResponseModel implements CompanyResponseInterface {
  address: string = '';
  companyId: number = -1;
  contributiveColaboratorPercentageValue: number = 0;
  contributiveFamilyPercentageValue: number = 0;
  contributiveRetiredPercentageValue: number = 0;
  location: string = '';
  name: string = '';
  nif: string = '';
  niss: string = '';
  phoneNumber: string = '';
  postalCode: string = '';
}
